import React from "react";
import { Link } from "react-router-dom";
import { usePermissionStore } from "@presentation/stores/PermissionStore";
import { settingsUrl } from "@presentation/common/settingsRoutes";

export const LicenseRequiredMessage: React.FC<{ software?: string }> = ({ software }) => {
  const isAdmin = usePermissionStore((state) => state.isAdmin);
  return (
    <>
      {software ? `${software} is not licensed in this deployment.` : "No licensed search engine."}{" "}
      {isAdmin ? (
        <Link to={settingsUrl({ level: "deployment" }, new URLSearchParams({ tab: "license" }))}>Add a license key in deployment license settings.</Link>
      ) : (
        "Ask your administrator to add a license key."
      )}
    </>
  );
};
